import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';

// @ts-ignore
@Options({})
export default class UserManager extends BaseVue {

  list: any = {
    list: [],
    pageNum: 0,
    pageSize: 0,
    pages: 0,
    size: 0,
    total: 0,
  };

  search: any = {
    name: null,
    deleted: null,
    openId: null,
    idCard: null,
    nickName: null,
    pi: 1,
    ps: 10
  };

  mounted() {
    this.getList(1);
  }

  gotoImg(img: string) {
    window.open(img)
  }

  getList(pi: number) {
    this.search.pi = pi;
    console.log(this.search);
    this.http.getAppUserList(this.search).then(res => {
      this.list = res.data;
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  deleted(item: any) {
    this.http.deletedUser({id: item.id}).then(res => {
      this.getList(1);
      this.toast_success(res.msg);
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  onReset() {
    this.search = {
      name: null,
      deleted: null,
      type: null,
      pi: 1,
      ps: 10
    };
    this.getList(1);
  }

}
